import React, { useState } from "react";
import { useDispatch } from 'react-redux';

import { resetFilters} from '../../store/filterSlice';

const Parameters = () => {
	const [isOpen, setIsOpen] = useState(false);
	const dispatch = useDispatch();

	const onResetFilters = () => {
		dispatch(resetFilters());
	}

	return (
		<ul className='parameters'>
			{/* <li>
				<span onClick={() => setIsOpen((isOpen) => !isOpen)}>
					{isOpen ? 'Скрыть' : 'Дополнительные параметры'}
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M11.9784 6.08671C11.9926 6.10995 12 6.1357 12 6.16188C11.9999 6.19452 11.9882 6.22642 11.9664 6.2533L8.15988 10.9303C8.12433 10.9739 8.06574 11 8.00306 11C7.94045 11 7.88179 10.9739 7.84624 10.9303L4.03343 6.2533C3.99314 6.2035 3.98895 6.13877 4.0226 6.08553C4.05625 6.03228 4.1221 5.9993 4.19342 6.00001L11.8096 6.00001C11.8805 6.00001 11.9456 6.03341 11.9784 6.08671Z" fill="#010620"/>
					</svg>
				</span>
				{isOpen && 
					<div>
						<div>
							<input type='checkbox' id="pool" />
							<label htmlFor='pool'>свой бассейн</label>
						</div>
						<div>
							<input type='checkbox' id="yard" />
							<label htmlFor='yard'>свой двор</label>
						</div>
					</div>
				}
			</li> */}
			{/* <li>
				<button type='button' onClick={onResetFilters}>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
						<path fillRule="evenodd" clipRule="evenodd" d="M4.81793 5.31793C5.01319 5.12267 5.32978 5.12267 5.52504 5.31793L7.99991 7.7928L10.4748 5.31793C10.67 5.12267 10.9866 5.12267 11.1819 5.31793C11.3772 5.51319 11.3772 5.82978 11.1819 6.02504L8.70702 8.49991L11.1819 10.9748C11.3772 11.17 11.3772 11.4866 11.1819 11.6819C10.9866 11.8772 10.67 11.8772 10.4748 11.6819L7.99991 9.20702L5.52504 11.6819C5.32978 11.8772 5.01319 11.8772 4.81793 11.6819C4.62267 11.4866 4.62267 11.17 4.81793 10.9748L7.2928 8.49991L4.81793 6.02504C4.62267 5.82978 4.62267 5.51319 4.81793 5.31793Z" fill="#AAAAAA"/>
						<path fillRule="evenodd" clipRule="evenodd" d="M4.71186 5.21187C4.96571 4.95802 5.37726 4.95802 5.6311 5.21187L7.99991 7.58067L10.3687 5.21187C10.6226 4.95802 11.0341 4.95802 11.288 5.21187C11.5418 5.46571 11.5418 5.87726 11.288 6.1311L8.91915 8.49991L11.288 10.8687C11.5418 11.1226 11.5418 11.5341 11.288 11.788C11.0341 12.0418 10.6226 12.0418 10.3687 11.788L7.99991 9.41915L5.6311 11.788C5.37726 12.0418 4.96571 12.0418 4.71186 11.788C4.45802 11.5341 4.45802 11.1226 4.71186 10.8687L7.08067 8.49991L4.71186 6.1311C4.45802 5.87726 4.45802 5.46571 4.71186 5.21187ZM5.41897 5.424C5.28229 5.28731 5.06068 5.28731 4.924 5.424C4.78731 5.56068 4.78731 5.78229 4.924 5.91897L7.39887 8.39385C7.45745 8.45242 7.45745 8.5474 7.39887 8.60598L4.924 11.0809C4.78731 11.2175 4.78731 11.4391 4.924 11.5758C5.06068 11.7125 5.28229 11.7125 5.41897 11.5758L7.89385 9.10095C7.95242 9.04237 8.0474 9.04237 8.10598 9.10095L10.5809 11.5758C10.7175 11.7125 10.9391 11.7125 11.0758 11.5758C11.2125 11.4391 11.2125 11.2175 11.0758 11.0809L8.60095 8.60598C8.54237 8.5474 8.54237 8.45242 8.60095 8.39385L11.0758 5.91897C11.2125 5.78229 11.2125 5.56068 11.0758 5.424C10.9391 5.28731 10.7175 5.28731 10.5809 5.424L8.10598 7.89887C8.0474 7.95745 7.95242 7.95745 7.89385 7.89887L5.41897 5.424Z" fill="#AAAAAA"/>
					</svg>
					Сбросить фильтры
				</button>
			</li> */}
		</ul>
	);
};

export default Parameters;
